import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';

import type { FooterItem } from './types';

type FooterLinkProps = FooterItem & {
  position: number;
};

type FooterNavProps = {
  label: string;
  links: FooterItem[];
};

function FooterLink({ external, link, name, position }: FooterLinkProps) {
  const fireFooterLink = useNavigationLinkInteraction('footer');
  const newWindowProps = external
    ? { rel: 'noopener noreferrer', target: '_blank' }
    : {};

  return (
    <a
      href={link}
      onClick={() => fireFooterLink(link, position, { label: name })}
      {...newWindowProps}
    >
      {name}
    </a>
  );
}

export function FooterNav({ label, links }: FooterNavProps) {
  return (
    <nav aria-label={label}>
      <ul className="flex flex-col gap-4">
        {links.map((item, index) => (
          <li key={item.name}>
            <FooterLink {...item} position={index + 1} />
          </li>
        ))}
      </ul>
    </nav>
  );
}

export function LegalNav({ label, links }: FooterNavProps) {
  return (
    <nav aria-label={label} className="desktop:flex-1">
      <ul className="flex flex-wrap items-center justify-center gap-4 desktop:justify-start">
        {links.map((item, index) => (
          <li className="flex items-center gap-4" key={item.name}>
            {index > 0 && (
              <span aria-hidden className="size-1 rounded-full bg-grey-read" />
            )}
            <FooterLink {...item} position={index + 1} />
          </li>
        ))}
      </ul>
    </nav>
  );
}
